// SlicePlugin definition for the sticky-note slice (PRD-E §TR1, §TR9, §TR10).
//
// Migrated to the discriminated-union CapabilityDescriptor form (PRD-X §TR3).
// Each entry carries explicit view/edit aspects so that downstream consumers
// (renderer, optionsbar, edit-mode controllers) can dispatch precisely.

import type { SlicePlugin } from '../../core/object-registry.js';
import {
  type CapabilityDescriptor,
  TEXT_CONTENT_VIEW,
  RESIZE_EDIT,
  ANCHOR_TARGET_VIEW,
  BG_COLOR_VIEW,
  BG_COLOR_EDIT,
  FONT_SIZE_VIEW,
  FONT_SIZE_EDIT,
  FONT_STYLE_VIEW,
  FONT_STYLE_EDIT,
  STACK_PRESENCE_VIEW,
  UPDATABLE_PROPERTIES_EDIT,
  RICH_EDIT,
} from '../../core/capabilities/capability.interface.js';
import type { StickyNote } from './sticky.interface.js';
import { createStickyDefaults } from './sticky-defaults.factory.js';
import { createNode, updateNode } from './sticky.renderer.js';

const STICKY_CAPABILITIES: readonly CapabilityDescriptor[] = [
  { capability: 'text-content', view: TEXT_CONTENT_VIEW },
  { capability: 'resize', edit: RESIZE_EDIT },
  { capability: 'anchor-target', view: ANCHOR_TARGET_VIEW },
  { capability: 'background-color', view: BG_COLOR_VIEW, edit: BG_COLOR_EDIT },
  { capability: 'font-size', view: FONT_SIZE_VIEW, edit: FONT_SIZE_EDIT },
  { capability: 'font-style', view: FONT_STYLE_VIEW, edit: FONT_STYLE_EDIT },
  { capability: 'stack-presence', view: STACK_PRESENCE_VIEW },
  { capability: 'updatable-properties', edit: UPDATABLE_PROPERTIES_EDIT },
  { capability: 'rich-edit', edit: RICH_EDIT },
];

export const stickySlice: SlicePlugin<StickyNote> = {
  type: 'sticky',
  role: 'primary',
  capabilities: STICKY_CAPABILITIES,
  display: {
    iconUrl: 'fa-note-sticky',
    label: 'Haftnotiz',
  },
  createDefaults: createStickyDefaults,
  createNode,
  updateNode,
  isAnchorTarget: () => true,
};
